



























































































































































































































































































































import { Component, Vue, Emit, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { DateTime } from 'luxon'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { maskMoney, maskCPFCNPJ, maskDateTime } from '@/utils/common'

@Component

export default class ComponentModalAtualizarNotaFiscal extends Vue {
  @Prop({ required: true, default: false }) disabled: boolean

  $refs!: {
    formRules: any,
    dateA: any,
    documentosPdf: any,
    documentosXml: any,
    documentosAdicionais: any
  }

  mensagemError: any = {
    dateText: '',
  }

  formRules: any = {
    valid: true,
    dataRecebimentoNota: [v => !!v || 'O campo data de recebimento da nota é obrigatório.'],
    numeroNota: [v => !!v || 'O campo número da nota é obrigatório.'],
    numeroContasPagar: [],
    comentario: [v => !!v || 'O campo comentário é obrigatório.'],
  }

  loadDeletar: any = null
  loadingDeletarDocumento: any = null
  loadConfirmar: boolean = false
  showMessageLimitDocuments: boolean = false
  motivo: any[] = []
  dateText: string = ''
  imageUrl: string = ''
  date: string = ''
  anexo: any = {}
  anexoXml: any = {}
  podeFazerUploadVal: boolean = true
  inputFilePDF: any[] = []
  inputFileXML: any[] = []
  inputFileDocumentosAdicionais: any[] = []
  notasFiscais: any[] = []
  notasExistentes: any[] = []
  documentosAdicionais: any[] = []
  loadingDownloadNf: any = null

  get loadingDeletar() {
    return this.loadDeletar
  }

  set loadingDeletar(value: any) {
    this.loadDeletar = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get isDisableConfirmar() {
    return this.getFinanceiroStore.disabledConfirmar
  }

  set isDisableConfirmar(value: boolean) {
    this.getFinanceiroStore.setDisabledConfirmar(value)
  }

  get podeFazerUpload() {
    return this.podeFazerUploadVal
  }

  set podeFazerUpload(value: boolean) {
    this.podeFazerUploadVal = value
  }

  set getMotivo(value: string[]) {
    const store = this.getFinanceiroStore

    if (!Array.isArray(store.prestadorRecebimento.notasFiscais)) {
      store.prestadorRecebimento.notasFiscais = []
    }

    if (store.prestadorRecebimento.notasFiscais.length === 0) {
      store.prestadorRecebimento.notasFiscais.push({
        createdByNome: '',
        createdOn: '',
        dataRecebimentoNota: '',
        descricaoDivergencia: '',
        divergencia: false,
        documentoId: '',
        motivo: [],
        nomeArquivoOriginal: '',
        notaCancelada: false,
        numeroContasPagar: '',
        numeroNota: '',
        prestadorRecebimentoId: '',
        situacao: '',
        valorNotaFiscal: 0,
        comentario: '',
      })
    }

    if (!Array.isArray(store.prestadorRecebimento.notasFiscais[0].motivo)) {
      store.prestadorRecebimento.notasFiscais[0].motivo = []
    }

    store.prestadorRecebimento.notasFiscais[0].motivo = [...value]
  }

  get getMotivo() {
    const { notasFiscais } = this.getFinanceiroStore.prestadorRecebimento

    if (!Array.isArray(notasFiscais) || notasFiscais.length === 0) {
      return []
    }

    return Array.isArray(notasFiscais[0].motivo) ? notasFiscais[0].motivo : []
  }

  get notaFiscalUnica() {
    return this.getFinanceiroStore.notaFiscalUnica || {}
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get showModalAtualizarNotaFiscal() {
    return this.getFinanceiroStore.modal.atualizarNotaFiscal
  }

  set showModalAtualizarNotaFiscal(value: boolean) {
    this.getFinanceiroStore.setModal({ name: 'atualizarNotaFiscal', value })
  }

  get prestadorRecebimento() {
    return this.getFinanceiroStore.prestadorRecebimento
  }

  get getDateText1() {
    this.dateText = this.formatISOToDate(this.date)
    return this.dateText
  }

  set getDateText1(value: string | Date) {
    this.dateText = this.formatISOToDate(this.date)
  }

  get anexoNotaFiscal() {
    return this.anexo
  }

  set anexoNotaFiscal(value: any) {
    this.anexo = value
  }

  get anexoNotaFiscalXml() {
    return this.anexoXml
  }

  set anexoNotaFiscalXml(value: any) {
    this.anexoXml = value
  }

  get acoesRecebimento() {
    return this.getFinanceiroStore.acoesItemRecebimento
  }

  get permiteDocumentosAdicionais() {
    return this.acoesRecebimento ? this.acoesRecebimento.habilitaDocumentoAdicional : false
  }

  get documentoAdicionalObrigatorio() {
    return this.acoesRecebimento ? this.acoesRecebimento.documentoAdicionalObrigatorio : false
  }

  get qtdDocumentosAdicionais() {
    if (!this.prestadorRecebimento || !Array.isArray(this.prestadorRecebimento.documentosAdicionais)) {
      return 0
    }

    const totalServidor = this.prestadorRecebimento.documentosAdicionais.length
    const carregadosNaLista = this.documentosAdicionais.filter((doc: any) => !!doc.id).length

    return Math.max(totalServidor - carregadosNaLista, 0)
  }

  get totalDocumentosAdicionais() {
    return this.qtdDocumentosAdicionais + this.documentosAdicionais.length
  }

  get minimoDocumentosAdicionais() {
    return this.acoesRecebimento ? this.acoesRecebimento.minimoDocumentoAdicional : 0
  }

  get maximoDocumentosAdicionais() {
    return this.acoesRecebimento ? this.acoesRecebimento.maximoDocumentoAdicional : 10
  }

  isDocumentosAdicionaisNoRange() {
    if (!this.permiteDocumentosAdicionais) {
      this.showMessageLimitDocuments = false
      return true
    }

    const minimoExigido = this.documentoAdicionalObrigatorio ? this.minimoDocumentosAdicionais : 0
    const total = this.totalDocumentosAdicionais

    this.showMessageLimitDocuments = total === this.maximoDocumentosAdicionais

    return total >= minimoExigido && total <= this.maximoDocumentosAdicionais
  }

  atualizarEstadoConfirmar() {
    const temPDFLocal = this.inputFilePDF.length > 0
    const temPDFNaTela = this.notasFiscais.some(nf => nf.nomeArquivoOriginal.toLowerCase().endsWith('.pdf'))
    const temPDF = temPDFLocal || temPDFNaTela

    if (!temPDF) {
      this.isDisableConfirmar = false
      this.podeFazerUpload = temPDFLocal
      return
    }

    const documentosValidos = this.isDocumentosAdicionaisNoRange()
    this.isDisableConfirmar = documentosValidos
    this.podeFazerUpload = temPDFLocal
  }

  formatISOToDate(value: string | Date) {
    if (value === '' || !value) return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATE_SHORT)
  }

  clickDateTime(event) {
    if (!this.date) {
      this.date = moment(new Date()).format('YYYY-MM-DD')
    }

    this.$refs.dateA.open(event)
  }

  async confirmar() {
    this.loadingConfirmar = true

    const { files } = this.$refs.documentosPdf.$refs.upload

    if (this.$refs.formRules.validate()) {
      const temPDF = this.inputFilePDF.length > 0
        || this.notasFiscais.some(nf => nf.nomeArquivoOriginal.toLowerCase().endsWith('.pdf'))

      if (!temPDF) {
        EventBus.$emit('setSnackbar', { show: true, text: 'É necessário anexar o PDF da nota fiscal', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return false
      }

      // Valida se há um novo arquivo ou mantém o nome do arquivo original
      if (!this.notaFiscalUnica.divergencia && files.length < 1 && this.notaFiscalUnica.nomeArquivoOriginal === '') {
        EventBus.$emit('setSnackbar', { show: true, text: 'É necessário anexar uma nota fiscal', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return false
      }

      // Verifica se não tem arquivos anexados e implementa lógica para excluir e atualizar
      const nfsExistentes = this.notasExistentes

      if (!this.acoesRecebimento.permiteMultiplasNFs && (this.acoesRecebimento.permiteNotaFiscalXml || this.acoesRecebimento.habilitaDocumentoAdicional) && nfsExistentes.length > 0 && this.inputFilePDF.length > 0) {
        for (let i = 0; i < nfsExistentes.length; i++) {
          const nota = nfsExistentes[i]

          const paramsDelete: any = {
            prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
            documentoId: nota.documentoId,
          }
          await this.getFinanceiroStore.deletarDocumento(paramsDelete)
        }
      }

      // Passo 1: Upload do arquivo apenas se houver um novo documento
      let notaFiscalUrl = this.notaFiscalUnica.notaFiscalUrl || ''
      if (files.length > 0 && this.podeFazerUpload) {
        const params: any = {
          documentoId: this.getFinanceiroStore.documentoId,
          prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
          formData: this.anexoNotaFiscal.formData,
        }
        const step1 = await this.getFinanceiroStore.uploadNotaFiscalUnica({ params, typeFile: 'pdf' })
        if (!step1.success) {
          EventBus.$emit('setSnackbar', { show: true, text: step1.message || 'Houve um problema ao enviar nota fiscal', icon: 'warning', color: '#C62828' })
          this.loadingConfirmar = false
          return false
        }

        notaFiscalUrl = step1.data.url ? step1.data.url : step1.data
      }

      // Passo 2: Upload XML (se existir)
      if (this.acoesRecebimento.permiteNotaFiscalXml && this.inputFileXML.length > 0) {
        const paramsXml: any = {
          documentoId: this.getFinanceiroStore.documentoId,
          prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
          formData: this.anexoNotaFiscalXml.formData,
        }

        const stepXML = await this.getFinanceiroStore.uploadNotaFiscalUnica({ params: paramsXml, typeFile: 'xml' })
        if (!stepXML.success) {
          EventBus.$emit('setSnackbar', { show: true, text: stepXML.message || 'Houve um problema ao enviar o XML da nota fiscal', icon: 'warning', color: '#C62828' })
          this.loadingConfirmar = false
          return false
        }
      }

      // 3. Upload documentos adicionais (se existir)
      if (this.permiteDocumentosAdicionais && this.inputFileDocumentosAdicionais.length > 0) {
        const formDataAdicionais = new FormData()

        // Adicionar todos os arquivos ao FormData
        this.inputFileDocumentosAdicionais.forEach((doc) => {
          formDataAdicionais.append('files', doc.file)
        })

        const params: any = {
          prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
          formData: formDataAdicionais,
        }

        const stepDoc = await this.getFinanceiroStore.uploadDocumentosAdicionais(params)
        if (!stepDoc.success) {
          EventBus.$emit('setSnackbar', { show: true, text: stepDoc.message || 'Houve um problema ao enviar os documentos adicionais', icon: 'warning', color: '#C62828' })
          this.loadingConfirmar = false
          return false
        }
      }

      // 4. Atualizar recebimento (sempre executar após uploads)
      const params: any = {
        prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
        motivo: this.getMotivo.length > 0 ? this.getMotivo : ['Nenhum'],
        divergencia: this.notaFiscalUnica.divergencia,
        notaFiscalUrl,
        documentoId: this.getFinanceiroStore.documentoId,
        numeroNota: this.notaFiscalUnica.numeroNota,
        numeroContasPagar: this.notaFiscalUnica.numeroContasPagar,
        comentario: this.notaFiscalUnica.comentario,
        valorNotaFiscal: this.getFinanceiroStore.prestadorRecebimento.valorRepasse,
      }

      if (this.isValid()) {
        params.dataRecebimentoNota = this.date
      }

      const response = await this.getFinanceiroStore.atualizarRecebimetno(params)

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal atualizada com sucesso', icon: 'done', color: '#2E7D32' })
        this.getFinanceiroStore.atualizarAcaoPodeProvisionar(this.getFinanceiroStore.prestadorRecebimento.id)
        await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema na atualização da nota fiscal', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingConfirmar = false
    return files
  }

  async deletar(nota: any, index: number) {
    let params: any = []
    const tipoArquivo = nota.nomeArquivoOriginal.split('.').pop()
    const temArquivoXml = this.notasFiscais.some(nf => nf.nomeArquivoOriginal.endsWith('.xml'))

    if (nota.documentoId === '') {
      this.notasFiscais.splice(index, 1)

      if (tipoArquivo === 'xml') {
        this.inputFileXML = []
        this.anexoNotaFiscalXml = {}
      } else if (tipoArquivo === 'pdf') {
        this.inputFilePDF = []
        this.anexoNotaFiscal = {}
      }

      this.atualizarEstadoConfirmar()
      return
    }

    this.loadingDeletar = index

    if (tipoArquivo === 'pdf' && temArquivoXml) {
      this.loadingDeletar = true

      params = this.notasFiscais.map(nf => ({
        prestadorRecebimentoId: nf.prestadorRecebimentoId,
        documentoId: nf.documentoId,
      }))
    } else {
      this.loadingDeletar = index

      params.push({
        prestadorRecebimentoId: nota.prestadorRecebimentoId,
        documentoId: nota.documentoId,
      })
    }

    for (const notaFiscal of params) {
      const response = await this.getFinanceiroStore.deletarDocumento(notaFiscal)

      if (response.success) {
        this.notasFiscais.splice(index, 1)

        // Remove também do array de notas existentes para não tentar deletar novamente ao confirmar
        const indexExistente = this.notasExistentes.findIndex(n => n.documentoId === notaFiscal.documentoId)
        if (indexExistente !== -1) {
          this.notasExistentes.splice(indexExistente, 1)
        }

        if (tipoArquivo === 'xml') {
          this.inputFileXML = []
          this.anexoNotaFiscalXml = {}
        } else if (tipoArquivo === 'pdf') {
          this.inputFilePDF = []
          this.anexoNotaFiscal = {}
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Nota Fiscal deletada com sucesso.',
          icon: 'done',
          color: '#2E7D32',
        })
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Houve um problema ao deletar a nota fiscal.',
          icon: 'warning',
          color: '#C62828',
        })
      }
    }
    this.loadingDeletar = null

    this.atualizarEstadoConfirmar()
  }

  async deletarDocumento(nota: any, index: number) {
    this.loadingDeletarDocumento = index

    if (!nota.documentoId && !nota.id) {
      this.documentosAdicionais.splice(index, 1)
      this.inputFileDocumentosAdicionais.splice(index, 1)
      this.loadingDeletarDocumento = null
      this.atualizarEstadoConfirmar()
      return
    }

    const params = {
      prestadorRecebimentoId: nota.prestadorRecebimentoId,
      documentoId: nota.id,
    }

    const response = await this.getFinanceiroStore.deletarDocumentoAdicional(params)

    if (response.success) {
      this.prestadorRecebimento.documentosAdicionais.splice(index, 1)
      this.documentosAdicionais.splice(index, 1)

      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Documento adicional deletado com sucesso.',
        icon: 'done',
        color: '#2E7D32',
      })
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Houve um problema ao deletar o documento adicional.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDeletarDocumento = null
    this.atualizarEstadoConfirmar()
  }

  clearDate() {
    if (this.getFinanceiroStore.prestadorRecebimento.notasFiscais) {
      this.getFinanceiroStore.prestadorRecebimento.notasFiscais[0].dataRecebimentoNota = ''
    }
  }

  async inputFile(newFile, typeFile?: string) {
    if (!newFile) return

    const { file } = newFile
    const { type } = file
    const fileName = file.name.toLowerCase()

    if (newFile.identifier) {
      return
    }

    const isValidXML = type === 'application/xml' || type === 'text/xml' || fileName.endsWith('.xml')
    const isValidPDF = type === 'application/pdf' || fileName.endsWith('.pdf')

    if (typeFile === 'adicionais') {
      if (!isValidPDF) {
        EventBus.$emit('setSnackbar', { show: true, text: 'O arquivo enviado não possui formato válido. Apenas PDF é permitido.', icon: 'warning', color: '#C62828' })
        return
      }

      this.documentosAdicionais.push({
        nomeArquivoOriginal: fileName,
        documentoId: '',
        file,
      })

      this.inputFileDocumentosAdicionais.push({ file })

      if (this.totalDocumentosAdicionais === this.maximoDocumentosAdicionais) {
        this.showMessageLimitDocuments = true
        return
      }

      this.atualizarEstadoConfirmar()
      EventBus.$emit('setSnackbar', { show: true, text: 'Documento adicional selecionado com sucesso.', icon: 'done', color: '#2E7D32' })
      return
    }

    if (this.acoesRecebimento.permiteNotaFiscalXml) {
      if (!isValidXML && !isValidPDF) {
        EventBus.$emit('setSnackbar', { show: true, text: 'O arquivo enviado não possui formato válido. Apenas PDF e XML são permitidos.', icon: 'warning', color: '#C62828' })
        return
      }
    } else if (!isValidPDF) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O arquivo enviado não possui formato válido. Apenas PDF é permitido.', icon: 'warning', color: '#C62828' })
      return
    }

    const formData = new FormData()
    formData.append('notaFiscal', file)

    const params: any = {
      formData,
      documentoId: this.getFinanceiroStore.documentoId,
      prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
    }

    if (this.notasExistentes.length > 0) {
      const notasDoServidor = this.notasFiscais.filter(nf => nf.documentoId !== '')

      if (notasDoServidor.length > 0) {
        this.notasFiscais = this.notasFiscais.filter(nf => nf.documentoId === '')
        this.inputFileXML = []
        this.inputFilePDF = []
        this.anexoNotaFiscalXml = {}
        this.anexoNotaFiscal = {}
      }
    }

    if (isValidXML) {
      this.anexoNotaFiscalXml = params
      this.inputFileXML = [file]

      const xmlIndex = this.notasFiscais.findIndex(nf => nf.nomeArquivoOriginal.endsWith('.xml'))
      if (xmlIndex !== -1) {
        this.notasFiscais.splice(xmlIndex, 1)
      }
    } else if (isValidPDF) {
      this.anexoNotaFiscal = params
      this.inputFilePDF = [file]

      const pdfIndex = this.notasFiscais.findIndex(nf => nf.nomeArquivoOriginal.endsWith('.pdf'))
      if (pdfIndex !== -1) {
        this.notasFiscais.splice(pdfIndex, 1)
      }
    }

    this.notaFiscalUnica.nomeArquivoOriginal = fileName

    if (this.acoesRecebimento.permiteMultiplasNFs) {
      this.notasFiscais.push({
        nomeArquivoOriginal: fileName,
        documentoId: '',
      })
    } else {
      const index = this.notasFiscais.findIndex(
        nf => nf.nomeArquivoOriginal.endsWith(type === 'application/pdf' ? '.pdf' : '.xml'),
      )

      const nota = {
        nomeArquivoOriginal: fileName,
        documentoId: '',
      }

      if (index >= 0) {
        this.notasFiscais.splice(index, 1, nota)
      } else {
        this.notasFiscais.push(nota)
      }
    }

    this.atualizarEstadoConfirmar()
    EventBus.$emit('setSnackbar', { show: true, text: `Arquivo ${isValidXML ? 'XML' : 'PDF'} selecionado com sucesso.`, icon: 'done', color: '#2E7D32' })
  }

  async download(prestadorRecebimentoId: string) {
    const response = await this.getFinanceiroStore.download({ prestadorRecebimentoId })
    const win = window.open()
    // @ts-ignore
    win.document.body.style.margin = '0'
    // @ts-ignore
    win.document.body.style.padding = '0'
    // @ts-ignore
    const iframe = win.document.createElement('iframe')
    iframe.src = response.data
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '')
    // Estilo via cssText (CSSOM): a CSP herdada pela janela bloqueia atributo style inline
    iframe.style.cssText = 'border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; margin:-8px;'
    // @ts-ignore
    win.document.body.appendChild(iframe)
  }

  async downloadNF(arquivo: any, index: number) {
    this.loadingDownloadNf = `${arquivo.nomeArquivoOriginal}-${index}`
    const id = arquivo.documentoId ? arquivo.documentoId : arquivo.id

    const response = await this.getFinanceiroStore.download({ prestadorRecebimentoId: id })
    const ext = (arquivo.nomeArquivoOriginal || '').toLowerCase().endsWith('.xml') ? 'xml' : 'pdf'
    const type = ext === 'xml' ? 'application/xml' : 'application/pdf'
    const { data } = response
    const blob = typeof data === 'string' && data.startsWith('data:')
      ? await (await fetch(data)).blob()
      : new Blob([data], { type })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = arquivo.nomeArquivoOriginal || `nota-fiscal.${ext}`
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)

    this.loadingDownloadNf = null
  }

  async closeModal() {
    this.showModalAtualizarNotaFiscal = false
    this.$refs.formRules.reset()
    this.isDisableConfirmar = false
    this.podeFazerUpload = false
    this.clearNfs()
    EventBus.$emit('changeModoVisualizacao', false)
  }

  isValid() {
    this.mensagemError.dateText = ''

    if (!this.date) {
      this.mensagemError.dateText = 'O campo data de recebimento da nota é obrigatório.'
      return false
    }

    return true
  }

  formatMoneyUtil(money: string) {
    return maskMoney(money)
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }

  maskDateTime(value: string) {
    return maskDateTime(value)
  }

  clearNfs() {
    this.notasFiscais = []
    this.notasExistentes = []
    this.inputFilePDF = []
    this.inputFileXML = []
    this.inputFileDocumentosAdicionais = []
    this.documentosAdicionais = []
    this.showMessageLimitDocuments = false
    this.anexoNotaFiscal = {}
    this.anexoNotaFiscalXml = {}
  }

  @Watch('date')
  onDateChange(value: string) {
    this.dateText = this.formatISOToDate(value)
  }

  @Watch('showModalAtualizarNotaFiscal')
  onShowModalAtualizarNotaFiscalChange(value: boolean) {
    if (value) {
      const nota = this.getFinanceiroStore.prestadorRecebimento.notasFiscais[0]
      this.notasExistentes = [...this.getFinanceiroStore.prestadorRecebimento.notasFiscais]
      this.notasFiscais = [...this.notasExistentes]
      this.documentosAdicionais = [...this.getFinanceiroStore.prestadorRecebimento.documentosAdicionais]

      this.date = nota ? nota.dataRecebimentoNota : ''
      this.dateText = this.formatISOToDate(this.date)
    } else {
      this.clearNfs()
    }

    this.atualizarEstadoConfirmar()
  }
}
